import { calculateAfterpayPrice, replaceAfterpayPriceInHTML } from '../../../helpers/afterpay-price'

interface AfterpayPriceProps {
  price: string | number | null | undefined
  messagingHTML?: string
  containerClass?: string
  onPriceCalculated?: (price: string | null) => void
}

/**
 * AfterpayPrice Component
 *
 * Calculates and displays the afterpay price (price divided by 4).
 * Can optionally replace the price in messaging HTML or return the calculated price via callback.
 */
export function AfterpayPrice({
  price,
  messagingHTML,
  containerClass,
  onPriceCalculated
}: AfterpayPriceProps) {
  const afterpayPrice = calculateAfterpayPrice(price)

  if (onPriceCalculated && afterpayPrice !== null) {
    onPriceCalculated(afterpayPrice)
  }

  if (messagingHTML && afterpayPrice) {
    return (
      <div
        className={containerClass}
        dangerouslySetInnerHTML={{ __html: replaceAfterpayPriceInHTML(messagingHTML, afterpayPrice) }}
      />
    )
  }

  if (!afterpayPrice) return null

  return (
    <span className={containerClass}>
      {afterpayPrice}
    </span>
  )
}
